var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-button", {
        staticStyle: { cursor: "pointer" },
        attrs: {
          type: "info",
          circle: "",
          loading: _vm.listLoading,
          icon: "el-icon-message",
        },
        on: { click: _vm.getList },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogTableVisible,
            title: "商家列表（" + _vm.list.length + "）",
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "relative",
                "min-height": "300px",
                height: "100%",
              },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                    "max-height": "700",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "ID", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "商家 LOGO",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.fileInfo
                              ? _c("el-image", {
                                  staticStyle: {
                                    height: "60px",
                                    width: "60px",
                                    "border-radius": "50%",
                                    border: "1px solid #ddd",
                                  },
                                  attrs: {
                                    src: scope.row.fileInfo.url
                                      ? scope.row.fileInfo.url
                                      : "https://fakeimg.pl/300/300",
                                    fit: "cover",
                                    "preview-src-list": [
                                      scope.row.fileInfo.url,
                                    ],
                                    lazy: true,
                                  },
                                })
                              : _c("el-image", {
                                  staticStyle: {
                                    height: "60px",
                                    width: "60px",
                                    "border-radius": "50%",
                                    border: "1px solid #ddd",
                                  },
                                  attrs: {
                                    src: "https://fakeimg.pl/300x300/",
                                    fit: "cover",
                                    "preview-src-list": [
                                      "https://fakeimg.pl/300/300",
                                    ],
                                    lazy: true,
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "名稱", prop: "name" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "統編",
                      width: "120",
                      prop: "vatNumber",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "負責人",
                      width: "160",
                      prop: "boss",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "電話",
                      width: "160",
                      prop: "tel",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "地址",
                      width: "200",
                      prop: "address",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "E-Mail",
                      width: "160",
                      prop: "mail",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "簽約期間", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.startDate) +
                                  " 至 " +
                                  _vm._s(scope.row.endDate) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "簽約狀態",
                      width: "100",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.handleStatus(
                                    scope.row.startDate,
                                    scope.row.endDate
                                  ).type,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.handleStatus(
                                      scope.row.startDate,
                                      scope.row.endDate
                                    ).text
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              layout: "prev, pager, next",
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }